/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const styles = require('./src/styles/styles.scss');
